module.exports = __webpack_public_path__ + "img/sol light.42a1b399.svg";